import { isMobile } from '../helpers/isMobile';

export const jackpotIcons = {
  1: 'clubs',
  2: 'diamond',
  3: 'heart',
  4: 'spades',
};
export const jackpotIconsAnimationPosition = [
  {
    id: 1,
    count: 0,
    isWin: false,
    positions: isMobile()
      ? [
          { x: -8, y: -160, scale: 1 },
          { x: 75.5, y: -160, scale: 1 },
          { x: 33.5, y: -153, scale: 0.55 },
        ]
      : [
          { x: -325.5, y: 121 },
          { x: -212, y: 121 },
          { x: -269, y: 130.5 },
        ],
  },
  {
    id: 2,
    count: 0,
    isWin: false,
    positions: isMobile()
      ? [
          { x: 206.5, y: -159, scale: 1 },
          { x: 282.5, y: -159, scale: 1 },
          { x: 245, y: -153, scale: 0.6 },
        ]
      : [
          { x: 645.5, y: 125 },
          { x: 533, y: 125 },
          { x: 587.5, y: 135 },
        ],
  },
  {
    id: 3,
    count: 0,
    isWin: false,
    positions: isMobile()
      ? [
          { x: -45, y: -254, scale: 1 },
          { x: 37.5, y: -254, scale: 1 },
          { x: -3.5, y: -249, scale: 0.5 },
        ]
      : [
          { x: -455.5, y: -67 },
          { x: -341, y: -67 },
          { x: -397, y: -53 },
        ],
  },
  {
    id: 4,
    count: 0,
    isWin: false,
    positions: isMobile()
      ? [
          { x: 249, y: -259, scale: 1 },
          { x: 327, y: -259, scale: 1 },
          { x: 287.5, y: -255, scale: 0.6 },
        ]
      : [
          { x: 656, y: -70 },
          { x: 768.5, y: -70 },
          { x: 712, y: -62 },
        ],
  },
];
